module.exports = __webpack_public_path__ + "img/small-1.de738534.webp";